import { INITIAL_STATE } from "../../constant";
import { showLoading, hideLoading, getType, globalNotification } from "../actions";

export default function globalReducers(state = INITIAL_STATE.global, action) {
    switch (action.type) {
        case getType(showLoading):
            return {
                ...state,
                isLoading: true,
            };
        case getType(hideLoading):
            return {
                ...state,
                isLoading: false,
            };
        case getType(globalNotification.successNotification):
        case getType(globalNotification.errorNotification):
            return {
                ...state,
                noticationMessage: action.payload,
            };
        case getType(globalNotification.hideNotification):
            return {
                ...state,
                noticationMessage: '',
            };
        default:
            return state;
    }
}